import { BreadcrumbItem } from '@src/api/common/BreadcrumbTypes';
import { PageTitle } from '@src/api/common/PageTitleType';

const Breadcrumbs: Array<BreadcrumbItem> = [
  {
    title: 'Admin',
    isLink: false,
  },
  { title: 'Follow Up Status', isLink: false },
];

const Title: PageTitle = {
  title: 'Follow Up Status',
};

export { Breadcrumbs, Title };
